import Record from './Record';
export default Record;